var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('E2ZoneDessin',{ref:"dessin",attrs:{"width":640,"height":430,"readonly":_vm.e2_countdown === null || _vm.e2_countdown === 0}})}
var staticRenderFns = []

export { render, staticRenderFns }